import React from "react";
import { Box, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

const primary = blue[50]; // #f44336

export default function ErrorPage() {
  // return (
  //   <Box
  //     sx={{
  //       display: "flex",
  //       justifyContent: "center",
  //       alignItems: "center",
  //       minHeight: "100vh",
  //       backgroundColor: primary,
  //     }}
  //   >
  //     <Typography variant="h1" style={{ color: "gray" }}>
  //       صفحه یافت نشد!
  //     </Typography>
  //   </Box>
  // );
  return (
    <div
      className=" errorPageImage"
      style={{
        backgroundImage: `url(${toAbsoluteUrl("/media/error/bg1.jpg")})`
      }}
    >
      <div style={{textAlign:"left",marginLeft:"100px"}}>
        <h1
          className="font-size-sm-100 font-weight-boldest text-dark-75 mt-15"
          style={{ fontSize: "150px" }}
        >
          404
        </h1>
        <p className="font-size-h3 font-weight-light">
          صفحه مورد نظر یافت نشد.
        </p>
      </div>
    </div>
  );
}
